var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 8 8",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46999 1.09496L0.142684 5.9659C-0.200356 6.46809 0.113948 7.1998 0.672698 7.1998H7.3273C7.88605 7.1998 8.20036 6.46809 7.85732 5.9659L4.53001 1.09496C4.26119 0.701421 3.73881 0.70142 3.46999 1.09496Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingIcon);
export default __webpack_public_path__ + "static/media/AscendingIcon.8322eeed270177aa37580555b73e8371.svg";
export { ForwardRef as ReactComponent };